import {
  CurrentPointOnboardingType,
  OnboardingState,
  PlayerTypesInFlow,
  SelectPlayerContentViewMode,
  SelectPlayerFlowType,
} from './types';

export const SELECT_PLAYER_FLOW_DEFAULT_PLAYER = 'WEB';

export const DEFAULT_CURRENT_POINT_ONBOARDING: CurrentPointOnboardingType = {
  id: undefined,
  address: undefined,
  stream: undefined,
  device: undefined,
  isEnabled: undefined,
};

export const DEFAULT_ONBOARDING_STATE: OnboardingState = {
  inFlow: false,
  flowType: undefined,
  isTemplateMode: false,
  contentViewMode: SelectPlayerContentViewMode.AUDIO_STREAM,
  currentPoint: DEFAULT_CURRENT_POINT_ONBOARDING,
  selectedPlayerInFlow: PlayerTypesInFlow.WEBPLAYER,
};

export const FLOWS_FOR_SHOW_DEVICE_BIND_SUCCESS = new Set([
  SelectPlayerFlowType.CREATE_POINT,
  SelectPlayerFlowType.CHANGE_DEVICE,
  SelectPlayerFlowType.CREATE_DEMO_POINT,
  SelectPlayerFlowType.CHANGE_DEMO_DEVICE,
  SelectPlayerFlowType.CHANGE_AUDIO_VIDEO_DEVICE,
]);

export const VIDEO_FLOWS = new Set([
  SelectPlayerFlowType.CREATE_DEMO_POINT,
  SelectPlayerFlowType.BIND_VIDEO_STREAM,
  SelectPlayerFlowType.CHANGE_DEMO_DEVICE,
]);

export const CHANGE_DEVICE_FLOWS = new Set([
  SelectPlayerFlowType.CREATE_POINT,
  SelectPlayerFlowType.CHANGE_DEVICE,
  SelectPlayerFlowType.CHANGE_DEMO_DEVICE,
  SelectPlayerFlowType.CREATE_DEMO_POINT,
  SelectPlayerFlowType.CHANGE_AUDIO_VIDEO_DEVICE,
]);

export const FLOWS_FOR_NOT_SHOW_STOP_ONBOARDING_WARNING = new Set([
  SelectPlayerFlowType.CHANGE_DEVICE,
  SelectPlayerFlowType.CHANGE_DEMO_DEVICE,
  SelectPlayerFlowType.CHANGE_AUDIO_VIDEO_DEVICE,
]);
